import React from 'react';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMSearchHelper from 'components/helpers/SMSearchHelper';
import 'react-mdl/extra/material.js';
import {Textfield} from 'react-mdl';
import SMMobileSearchFormView from 'components/header/SMMobileSearchFormView';

class SMMobileSearchFilterView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      eventType: this.props.eventType || '',
      keyword: this.props.keyword || '',
      amenities: this.props.amenities || '',
      minPrice: this.props.minPrice || '',
      maxPrice: this.props.maxPrice || '',
      minCapacity: this.props.minCapacity || '',
      maxCapacity: this.props.maxCapacity || '',
      hasDirectReservationPlans: '',
      hasLastMinuteDiscountPlans: '',
      isOpen: false,
    };

    const featureAmenityList = SMSearchHelper.featureAmenityList(this.props.eventType, this.props.amenityList);
    this.amenityList = [];
    this.props.amenityList.forEach((amenity)=>{
      let isFeature = false;
      featureAmenityList.some((feature)=>{
        if (amenity.id == feature.id) {
          isFeature = true;
          return true;
        }
      });
      if (isFeature) return;
      this.amenityList.push(amenity);
    });
    this.amenityList = featureAmenityList.concat(this.amenityList);
  }

  componentDidMount() {
    const $body = $('body');
    this.top = $body.scrollTop();
    $body.scrollTop(0);
    $('.site-main').hide();
    $('#js-site-footer').hide();
    this.setState({isOpen: true});
  }

  componentWillUnmount() {
    $('.site-main').show();
    $('#js-site-footer').show();
    this.setState({isOpen: false});
    $('body').scrollTop(this.top);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.amenities != this.state.amenities) {
      this.setState({amenities: nextProps.amenities});
    }
  }

  eventTypeDidSelect(eventType) {
    this.setState({eventType: eventType});
  }

  priceRangeDidChange(e) {
    let state = state;
    state[e.currentTarget.name] = e.currentTarget.value;
    this.setState(state);
  }

  keywordDidChange(e) {
    this.setState({keyword: e.currentTarget.value});
  }

  amenityDidSelect(e){
    const str = this.state.amenities;
    let amenities = str != "" ? str.split(",") : [];
    const value = e.currentTarget.value;
    let existIndex = amenities.indexOf(value);
    if (existIndex == -1) amenities.push(value);
    else amenities.splice(existIndex, 1);

    this.setState({amenities: amenities.join(',')});
  }

  searchFieldDidFocus(e) {
    e.currentTarget.blur();
  }

  cancelDidSelect(e) {
    if (this.props.delegate && typeof this.props.delegate.toggleSearchFilter === 'function'){
      this.props.delegate.toggleSearchFilter();
    }
  }

  directReservationDidSelect(e){
    this.setState({
      hasDirectReservationPlans: !this.state.hasDirectReservationPlans
    });
  }

  lastMinuteDiscountDidSelect(e){
    this.setState({
      hasLastMinuteDiscountPlans: !this.state.hasLastMinuteDiscountPlans
    });
  }

  render() {
    if (!SMAppHelper.isMobile()) return null;
    const amenityType = this.state.eventType == 'stay' ? SMConst.AmenityType.Stay : SMConst.AmenityType.All;
    const selectedString = this.state.amenities || "";
    const selectedNames = selectedString.split(",");
    const mainStyle = this.state.isOpen ? {} : {display: 'none'};

    return (
      <div className="search-filter-mod search-filter-mod-head">
        <div className="search-box" style={mainStyle}>
          <form method="get" action={Routes.search_index_path()}>
            <div className="search-box__main">
              <SMMobileSearchFormView
                eventType={this.state.eventType}
                priceType={this.props.priceType}
                location={this.props.location}
                geocode={this.props.geocode}
                capacity={this.props.capacity}
                startedAt={this.props.startedAt}
                endedAt={this.props.endedAt}
                minCapacity={this.state.minCapacity}
                maxCapacity={this.state.maxCapacity}
                eventTypeList={this.props.eventTypeList}
                spaceTypeList={this.props.spaceTypeList}
                capacityList={this.props.capacityList}
                amenityList={this.props.amenityList}
                delegate={this} />
              <div ref="buttonArea" className="search-box__button-area js-search-box__button-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="search-box-button">
                      <input onClick={this.cancelDidSelect.bind(this)} className="form-btn form-btn__gray form-btn-m form-btn-search" type="button" value="キャンセル" />
                      <input className="form-btn form-btn__blue form-btn-m form-btn-search" type="submit" value="保存して検索する" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="js-search-filter-mod-sub__mobile">
              <div className="search-box__option">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-12 col-sm-11 col-md-8">
                      <div className="search-slider__area js-slider__horizontal">
                        <h2 className="search-change__main-title">価格帯</h2>
                        <div id="js-slider__range" ref="priceSlider"></div>
                        <div className="search-slider__pricebox clearfix">
                          <div className="fl">
                            <input name="min_price" placeholder="0" onChange={this.priceRangeDidChange.bind(this)} type="number" value={this.state.minPrice} className="search-slider__input" /><span className="search-slider__price">円〜</span>
                          </div>
                          <div className="fr">
                            <input name="max_price" placeholder="100000" onChange={this.priceRangeDidChange.bind(this)} type="number" value={this.state.maxPrice} className="search-slider__input" /><span className="search-slider__price">円</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="search-box__option">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <h2 className="search-change__main-title search-change__main-title-keyword">キーワード</h2>
                      <Textfield
                        type="text"
                        name="keyword"
                        onChange={this.keywordDidChange.bind(this)}
                        value={this.state.keyword}
                        className="w100pa"
                        label="古民家 おしゃれ" />
                    </div>

                    <div className="col-xs-12">
                      <h2 className="search-change__main-title">今すぐ予約</h2>
                      <div className="row">
                        <ul className="search-change__option">
                          <li className="search-change__option-checkbox col-xs-12">
                            <input type="checkbox" value={true} id="has_direct_reservation_plans" name="has_direct_reservation_plans" checked={this.state.hasDirectReservationPlans == true} onChange={this.directReservationDidSelect.bind(this)} />
                            <label htmlFor="has_direct_reservation_plans" className="form-checkbox__s">
                              <i className="fa fa-flash search-change__direct-icon"></i>今すぐ予約可能なプランあり
                              <span className="mod-evaluate__help ml5 sm-hide">
                                <i className="fa fa-question-circle"></i>
                                <span className="mod-tooltip mod-evaluate__help-tooltip">
                                  <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                                    <span className="baloon-inner">ホストの承認なしに即時に予約が完了するプランを持つスペースです。</span>
                                  </span>
                                </span>
                              </span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="col-xs-12">
                      <h2 className="search-change__main-title">直前割</h2>
                      <div className="row">
                        <ul className="search-change__option">
                          <li className="search-change__option-checkbox col-xs-12">
                            <input type="checkbox" value={true} id="has_last_minute_discount_plans" name="has_last_minute_discount_plans"
                              checked={this.state.hasLastMinuteDiscountPlans == true}
                              onChange={this.lastMinuteDiscountDidSelect.bind(this)} />
                            <label htmlFor="has_last_minute_discount_plans" className="form-checkbox__s">
                              <i className="icon-spm-discount search-change__discount-icon"></i>直前割対応プランあり
                              <span className="mod-evaluate__help ml5 sm-hide">
                                <i className="fa fa-question-circle"></i>
                                <span className="mod-tooltip mod-evaluate__help-tooltip">
                                  <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                                    <span className="baloon-inner">利用日から5日前までの予約で割引があるプランを持つスペースです。</span>
                                  </span>
                                </span>
                              </span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="col-xs-12">
                      <h2 className="search-change__main-title">アメニティ・設備</h2>
                      <div className="row">
                        <input type="hidden" name="amenities" value={this.state.amenities} />
                        <div className="search-change__amenity">
                          {this.amenityList.map((amenity)=>{
                            if (this.state.eventType == 'stay') {
                              if (amenity.amenity_type == SMConst.AmenityType.Rental) return null;
                            } else {
                              if (amenity.amenity_type == SMConst.AmenityType.Stay) return null;
                            }
                            const id = "form-amenity__checkbox" + amenity.id;
                            const checked = selectedNames.indexOf(amenity.name) != -1;
                            return (
                              <div key={id} className="search-change__amenity-checkbox col-xs-6 col-sm-4 col-md-4">
                                <input type="checkbox" checked={checked} value={amenity.name} id={id} onChange={this.amenityDidSelect.bind(this)} />
                                <label htmlFor={id} className="form-checkbox__s">{amenity.name_text}</label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="hidden" name="with_recommend" value={true} />
          </form>
        </div>
      </div>
    );
  }
}
export default SMMobileSearchFilterView;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMMobileSearchFilterView.jsx